/**
 * Boot native Capacitor chrome (back button, status bar, keyboard).
 * Safe to call from index.tsx; no-ops when not running in a Capacitor shell.
 */
import { Preferences } from '@capacitor/preferences';
import { setupAndroidBackButton, setupNativeChrome } from './nativeChrome';

// Side-effect import registers Preferences on window.Capacitor.Plugins for tokenStorage.
void Preferences;

export async function initNativeShell() {
  await setupNativeChrome();
  return setupAndroidBackButton();
}
